import React from "react";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { buildWhatsAppUrl } from "@/data/translations";
import { trackEvent } from "@/lib/analytics";

export default function FloatingWhatsApp() {
  const { t } = useLanguage();
  return (
    <a
      href={buildWhatsAppUrl(t.common.whatsappMsg)}
      onClick={() => {
        trackEvent("whatsapp_click", {
          metadata: { source: "floating_whatsapp" },
        });
        trackEvent("contact_click", {
          metadata: { source: "floating_whatsapp", channel: "whatsapp" },
        });
      }}
      target="_blank"
      rel="noopener noreferrer"
      className="chrome-focus-ring fixed bottom-[max(1rem,env(safe-area-inset-bottom))] right-4 md:bottom-5 md:right-5 z-40 inline-flex items-center justify-center h-[52px] w-[52px] md:h-14 md:w-14 rounded-full border border-white/60 bg-[#25D366] hover:bg-[#1EBE5C] text-white shadow-[0_14px_32px_rgba(37,211,102,0.26)] hover:-translate-y-0.5 transition-all"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
    >
      <span className="absolute inset-[3px] rounded-full border border-white/20 pointer-events-none" />
      <MessageCircle className="w-[22px] h-[22px] relative" />
    </a>
  );
}
